import { Component, OnInit, Inject } from '@angular/core';
import { MantenimientosService } from 'src/app/core/services/mantenimientos.service';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { Regimenes } from 'src/app/core/models/regimenes';

@Component({
  selector: 'app-insertar-regimen',
  templateUrl: './insertar-regimen.component.html',
  styleUrls: ['./insertar-regimen.component.scss']
})
export class InsertarRegimenComponent implements OnInit {

  regimen:Regimenes=new Regimenes();
  existError:boolean=false;
  mensajeError:string;
  isChecked:boolean=false;
  isActiva:string;

  constructor(private miservicio:MantenimientosService,
    public thisDialogRef: MatDialogRef<MatDialog>, @Inject(MAT_DIALOG_DATA) public data: {habitacion:Regimenes}) { }

  ngOnInit() {
  }

  guardar(){   
    //console.log(this.isChecked);
    if(this.isChecked){
      this.isActiva="S"
    }else{
      this.isActiva="N"
    }

    this.miservicio.postRegimen(this.regimen,this.isActiva).subscribe(datos=>{
      //console.log(datos)
      //this.thisDialogRef.close();
      if(datos.miRespuesta.booOk===true){
        this.thisDialogRef.close(datos.miListRegimenes);
      }else{
        this.mensajeError=datos.miRespuesta.strMensaje;
        this.existError=true;
      }
    })
  }

  cancelar(){
    this.thisDialogRef.close(this.data);
  }

}
